export const singleBenifits = [
  {
    id: 1,
    icon: "efficiency",
    title: "Efficiency",
    text: `streamlines and automates batch token operations, saving you valuable time and effort.`,
  },
  {
    id: 2,
    icon: "convenience",
    title: "Convenience",
    text: `Eliminating manual, repetitive processes and task.`,
  },
  {
    id: 3,
    icon: "security",
    title: "Security",
    text: `Alchemis Tokentool is built on a decentralized architecture, leveraging the power of blockchain technology.`,
  },
  {
    id: 4,
    icon: "versatility",
    title: "Versatility",
    text: `Whether you're an individual user, a crypto project, or a blockchain enterprise, TokenTool caters to your diverse token management needs.`,
  },
  {
    id: 5,
    icon: "user-friendly",
    title: "User-Friendly Interface",
    text: `TokenTool provides an intuitive and user-friendly interface, making it accessible to users of all experience levels.`,
  },
];
